/**
 * @file
 */
import scrollList from './scrollList.vue';

scrollList.install = function (Vue) {
    Vue.component(scrollList.name, scrollList);
};

export default scrollList;
